import { Icon } from "@portal/components/primitives";
import { ToolIcon } from "@portal/components/ui/ToolIcon";

export const AdminDecisioningIcon = (props: { onClick?: () => void; className?: string }) => (
	<ToolIcon icon={<Icon type="scale" size="small" />} label="Decisioning" {...props} />
);
